import { useEffect } from "react";

import { useHistory } from "react-router-dom";

import { useCountry } from "~/v2/api/hooks/useCountry";
import { Path } from "~/v2/path";
import { useGetMarketDataSubscriptionDetails } from "../util";
import { useMarketDataSubscribeController } from "./Subscribe.controller";
import { SubscribePresentation } from "./Subscribe.pres";

export const SubscribeConnector = () => {
  const history = useHistory();

  const {
    account,
    details,
    isSubscribed,
    isLoading: isDataLoading,
    ...restDetails
  } = useGetMarketDataSubscriptionDetails();

  const { isLoading, ...restController } = useMarketDataSubscribeController({
    account,
    details,
    isDataLoading,
  });

  const country = useCountry();

  useEffect(() => {
    if (isDataLoading || !isSubscribed) {
      return;
    }

    if (isSubscribed) {
      history.push(Path.ROUTE_MARKET_DATA);
    }
  }, [isDataLoading, isSubscribed, history.push]);

  return (
    <SubscribePresentation
      account={account}
      details={details}
      isSubscribed={isSubscribed}
      isLoading={isLoading || country.isLoading}
      country={country}
      {...restDetails}
      {...restController}
    />
  );
};
